import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import AttendanceInsights from "./routes/AttendanceInsights";
import CourseExcusals from "./routes/CourseExcusals";
import ProfileV2 from "Platform/routes/ProfileV2";
export default store => ({
  path: "attendance",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-attendance" */ "./components"),
        import(
          /* webpackChunkName: "course-attendance" */ "./modules/AttendanceModule"
        ),
        import(
          /* webpackChunkName: "course-attendance" */ "AdminTimetable/modules/TimetableModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        const timetableReducer = importedModule2.default;
        injectReducer(store, {
          key: "attendance",
          reducer,
        });
        injectReducer(store, {
          key: "timetableAdmin",
          reducer: timetableReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    CourseExcusals(store),
    AttendanceInsights(store),
    ProfileV2(store),
  ],
});
